export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const SET_SESSION = 'SET_SESSION';
export const SET_UNAUTHORIZED = 'SET_UNAUTHORIZED';
export const UPDATE_SESSION = 'UPDATE_SESSION';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const SYNC_FROM_STORAGE = 'SYNC_FROM_STORAGE';
